<div id="assignment-opportunity-popup" class="assignment-opportunity-popup modal fade modal-window" tabindex="-1"
  role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body pb-1 modal-OpportunityBody">
        <div class="row m-0">
          <div class="col-md-11 pl-4">
            <div class="row pop-up-pageTitle"> Choose the solution code for this new assignment</div>
            <div class="row d-flex alignment">
              <div class="pl-0 pb-2">
                <span class="selectedclientName">{{assignmentPopupModel.clientName}} </span>
              </div>
            </div>
          </div>

          <div class="col-md-1 p-0">
            <button type="button" class="close edp-font-14" data-dismiss="modal" aria-hidden="true"
              (click)="CancelOpportunityPopUp();">
              <span class="close-text mr-1">Close </span>
              <span class="modal-close-btn">&times;</span>
            </button>
          </div>
        </div>

        <div class="row pl-2 m-0 p-0 col-md-12">Select the opportunity service(s) to associate with this engagement.</div>
        <div class="row pl-2 m-0 p-0 col-md-12">
          <div class="col-md-3 r-n-res-checkboxNew px-0 ">
            <img src="assets/images/EDP/Workspace/blue_lagend.png" alt="chk_UnrelatedService" width="20" height="20"
              class="img-responsive blue_lagend">
            <label class="custom-check-no-pointer edp-font-12" for="chk_RelatedService">Related service
              offering</label>
          </div>

          <div class="col-md-3 r-n-res-checkboxNew px-0 ">
            <img src="assets/images/EDP/Workspace/icon-unrelated-service.svg" alt="chk_UnrelatedService" width="20"
              height="20" class="img-responsive blue_lagend">
            <label class="custom-check-no-pointer edp-font-12" for="chk_UnrelatedService">Ineligible service
              offering</label>
          </div>

          <div class="col-md-3 r-n-res-checkboxNew px-0 ">
            <img src="assets/images/EDP/Workspace/report_problem_warning.svg" alt="Warning" width="20" height="20"
              height="20" class="img-responsive blue_lagend">
            <label class="custom-check-no-pointer edp-font-12" for="chk_CurrentlyAssigned">Linked to another
              assignment</label>
          </div>

          <div class="col-md-2 r-n-res-checkboxNew px-0 ">
          </div>
        </div>

        <div class="tableScroll m-0 row mt-1">
          <table id="tblOpportunity" class="table mb-0 table-border" aria-describedby="opportunity">
            <thead>
              <tr>
                <th>Solution code</th>
                <th>Solution description</th>
                <th>Opportunity</th>
                <th>Service amount
                  <img alt="add" src="../../../../assets/images/Client/tooltip.svg" class="Clientooltip"
                    data-toggle="tooltip" data-custom-class="tooltipIndicators" data-html="true"
                    data-title="This value for estimated net fees from oneView can be updated in the assignment setup in Engage." />
                </th>
                <th>Expected start date</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let opportunity of assignmentPopupModel.clientOpportunityList; let i=index">
                <tr id="clientOpportunityService" name="clientOpportunityService"
                  *ngFor="let service of opportunity.opportunityServiceList; let j=index; trackBy: trackByService"
                  [ngClass]="{'PartOfSecondary-background': service.isPartOfSecondary, 'service-bold': service.isPrimary}">

                  <td class="thHeadOne" [ngClass]="{'PartOfSecondary-background': service.isPartOfSecondary }">
                    <label class="custom-check edp-font-12"
                      [ngClass]="{'related-service': (!service.isEnabled && service.isPartOfSecondary), 'unrelated-service':(!service.interchangeableSolutionCodeFlag && !service.isPartOfSecondary),'cursor-default-important':service.isAssigned==true}"
                      for="assignment_opportunity_popup_chkSolutionCode{{i}}_{{j}}"
                      id='assignment_opportunity_popup_solutionCode{{i}}_{{j}}'>{{service.solutionCode}}
                      <input type='checkbox' name='assignment_opportunity_popup_chkSolutionCode{{i}}_{{j}}'
                        id='assignment_opportunity_popup_chkSolutionCode{{i}}_{{j}}' [(ngModel)]='service.isChecked'
                        (click)='onAssignmentOpportunityServiceClick(opportunity.opportunityId, service.opportunityServiceId, service.isChecked, 0, 0, true)'
                        [disabled]="service.isAssigned==true||(!service.isEnabled)">
                      <span
                        *ngIf="!service.isContinuanceCarryFrwdAssignment || !isPageLoadOnInitiatingContinuanceEngagement"
                        class="checkmark-custom"></span>
                      <span *ngIf="service.isAssigned==true" class="checkmark-custom"
                        [ngClass]="{'checkmark-disabled':service.isAssigned==true }"></span>
                      <span
                        *ngIf="(!service.interchangeableSolutionCodeFlag && !service.isPartOfSecondary && service.isAssigned==true)"
                        class="checkmark-custom"></span>
                    </label>
                  </td>
                  <td class="thHeadTwo" [ngClass]="{'PartOfSecondary-background': service.isPartOfSecondary }">
                    <img *ngIf="service.isAssigned && !service.isContinuanceCarryFrwdAssignment"
                      src="assets/images/EDP/Workspace/report_problem_warning.svg" alt="Warning" width="20" height="20"
                      class="img-responsive blue_lagend">
                    <img *ngIf="service.isContinuanceCarryFrwdAssignment && isPageLoadOnInitiatingContinuanceEngagement"
                      src="assets/images/EDP/Dashboard/redo-24px-cont.svg" alt="Continuance" width="20" height="20"
                      class="img-responsive blue_lagend">
                    <span id='assignment_opportunity_popup_solutionCodeDesc{{i}}_{{j}}'
                      class="alignSub">{{service.solutionDescription}}</span>
                  </td>
                  <td class="thHeadThree" [ngClass]="{'PartOfSecondary-background': service.isPartOfSecondary }">
                    {{opportunity.opportunityName}}</td>
                  <td class="paddingRight thHeadFour text-left"
                    [ngClass]="{'PartOfSecondary-background': service.isPartOfSecondary }">
                    <span id='assignment_opportunity_popup_estimatedNetFees{{i}}_{{j}}'>
                      {{(service.isContinuanceCarryFrwdAssignment
                      &&
                      isPageLoadOnInitiatingContinuanceEngagement) ? 'N/A' :
                      service.priceAmtFormattedValue}}</span>
                  </td>
                  <td class="thHeadFive" [ngClass]="{'PartOfSecondary-background': service.isPartOfSecondary }">
                    {{opportunity.expectedStartDate | date : "MM/dd/yy"}}</td>
                  <td class="thHeadSix" [ngClass]="{'PartOfSecondary-background': service.isPartOfSecondary }">&nbsp;
                  </td>

                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
      <div class="pl-0  pr-5 d-block pb-4">

        <div class="row m-0 p-0 label error-color edp-font-12 opportunityServiceErrorMessage" *ngIf="validateOpportunityService &&
            !oneViewClientOpportunityViewModelWrapper.isOpportunitySelected &&
            !oneViewClientOpportunityViewModelWrapper.isOpportunityServicelisted && isAddAssignmentClicked">
          <p *ngIf="assignmentPopupModel.clientOpportunityList.length > 0">
            <span>{{opportunityServiceErrorMessage}}</span>
          </p>
          <p *ngIf="assignmentPopupModel.clientOpportunityList.length == 0" class="edp-font-14">Click on check box
            "The opportunity
            service is not listed."</p>
        </div>
        <div class="row m-0 p-0 label error-color edp-font-12 opportunityServiceLinkErrorMessage"
          *ngIf="oneViewClientOpportunityViewModelWrapper.isOpportunitySelected ">
          <span>{{opportunityServiceLinkErrorMessage}}</span>
        </div><br />
        <div class="m-0 p-0 float-right">
          <button type="button" class="SecondaryButton mr-2 Btn150" data-dismiss="modal" id="btnCancelOpportunityNew"
            (click)="CancelOpportunityPopUp();">
            <span class="d-inline-block mr-1 align-top">
              <img alt="OK" src="../../../../assets/images/EDP/MessageDialog/cancel-blue.svg">
            </span>
            <span class="d-inline-block align-middle">Cancel</span>
          </button>
          <button type="button" class="PrimaryButton Btn150" id="btnOkOpportunityNew" (click)="OkOpportunityPopUp();">
            <span class="d-inline-block mr-1 align-top">
              <img alt="OK" src="../../../../assets/images/EDP/MessageDialog/delete-white.svg">
            </span>
            <span class="d-inline-block align-middle">OK</span>
          </button>
        </div>
      </div>
    </div>
  </div>

</div>